import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const LessonReviewApiUtils = {
  create(lessonId, audio, total, review) {
    return xhr(`${ApiConstants.SaveReview}/${lessonId}`, {
      method: 'post',
      body: JSON.stringify({
        total,
        audio,
        review,
      }),
    });
  },

  fetchByTutor(tutorId, page) {
    const query = `?page=${page}`;
    return xhr(`${ApiConstants.FetchLessonReviewsByTutor}/${tutorId}${query}`);
  },
};

export default LessonReviewApiUtils;
